import { BaseModel } from '@models/generic.model'
import { NoticeSession } from '@models/planning/notice-session.model'
import { DisputeQuotaType, disputeQuotaTypeLabel, isRestrictedQuota } from '@utils/small-business-quota.util'

export class NoticeSessionBatch extends BaseModel {
	description: string
	externalCode: string
	ordering: number
	noticeSession: NoticeSession
	/** Cota ME/EPP do lote e a origem do lote reservado (spec 045). Os itens seguem o lote. */
	quotaType?: DisputeQuotaType | null
	quotaSourceBatchId?: string | null

	get quotaTypeLabel(): string {
		return disputeQuotaTypeLabel(this.quotaType)
	}

	get restrictedToSmallBusiness(): boolean {
		return isRestrictedQuota(this.quotaType)
	}

	constructor(source?: Partial<NoticeSessionBatch>) {
		super(source)

		if (source) {
			Object.assign(this, source)
			this.label = source.description

			if (source.noticeSession) {
				this.noticeSession = new NoticeSession(source.noticeSession)
			}
		}
	}
}

export class NoticeSessionBatchPartialRequest extends BaseModel {
	description?: string
	ordering?: number

	constructor(source?: Partial<NoticeSessionBatchPartialRequest>) {
		super(source)

		if (source) {
			Object.assign(this, source)
		}
	}
}
